<template>
    <div>
        <app-k-v
            titulo="Atualizado em"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.ultimaAtualizacao"
        ></app-k-v>
        <app-k-v
            :titulo="isPJ ? 'CNPJ' : 'CPF'"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.cpfCnpj"
        ></app-k-v>
        <app-k-v
            :titulo="isPJ ? 'Razão Social' : 'Nome'"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.nome"
        ></app-k-v>
        <app-k-v
            v-if="isPJ"
            titulo="Nome Fantasia"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.nomeFantasia"
        ></app-k-v>
        <app-k-v
            titulo="Email"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.email"
        ></app-k-v>
        <app-k-v
            titulo="Telefone"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.telefone"
        ></app-k-v>
        <h5 class="heading-1 mt-4">
            <span>ENDEREÇO</span>
        </h5>
        <app-k-v
            titulo="Logradouro"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.logradouro"
        ></app-k-v>
        <app-k-v
            titulo="Número"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.numero"
        ></app-k-v>
        <app-k-v
            titulo="Complemento"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.complemento"
        ></app-k-v>
        <app-k-v
            titulo="Bairro"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.bairro"
        ></app-k-v>
        <app-k-v
            titulo="Cidade"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.cidade"
        ></app-k-v>
        <app-k-v
            titulo="UF"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.uf"
        ></app-k-v>
        <app-k-v
            titulo="CEP"
            :md="md"
            :lg="lg"
            :xl="xl"
            :dado="fornecedor.cep"
        ></app-k-v>
    </div>
</template>

<script>
export default {
    props: {
        fornecedor: {
            type: Object,
            default: () => {}
        },

        md: {
            type: Number,
            default: () => 3
        },

        lg: {
            type: Number,
            default: () => 2
        },

        xl: {
            type: Number,
            default: () => 1
        }
    },

    data() {
        return {}
    },

    computed: {
        isPJ() {
            return this.fornecedor.cpfCnpj.length == 18
        }
    }
}
</script>
